/* eslint-disable react/no-multi-comp */

import { lazy, Suspense, Component } from 'react';
import AsyncComponentLoading from './AsyncComponentLoading';
import SkeletonCircle from 'conversations-skeleton-state/components/SkeletonCircle';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingComponent = props => {
  return (
    /*#__PURE__*/
    // @ts-expect-error ts-migrate(2786) FIXME: 'AsyncComponentLoading' cannot be used as a JSX co... Remove this comment to see the full error message
    _jsx(AsyncComponentLoading, Object.assign({
      LoadingIndicator: /*#__PURE__*/_jsx(SkeletonCircle, {})
    }, props))
  );
};
LoadingComponent.displayName = 'AsyncUIAvatarLoading';
const SmallerLoadingComponent = props => {
  return (
    /*#__PURE__*/
    // @ts-expect-error ts-migrate(2786) FIXME: 'AsyncComponentLoading' cannot be used as a JSX co... Remove this comment to see the full error message
    _jsx(AsyncComponentLoading, Object.assign({
      LoadingIndicator: /*#__PURE__*/_jsx(SkeletonCircle, {
        size: 25
      })
    }, props))
  );
};
SmallerLoadingComponent.displayName = 'AsyncUIAvatarLoading';
const ErrorComponent = () => /*#__PURE__*/_jsx(UIIconCircle, {
  name: "blank",
  size: 11,
  color: BATTLESHIP,
  borderWidth: 0,
  backgroundColor: BATTLESHIP
});
ErrorComponent.displayName = 'AsyncUIAvatarError';
const UIAvatar = /*#__PURE__*/lazy(() => import(
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
/* webpackChunkName: "async-ui-avatar" */
'ui-addon-avatars/UIAvatar'));
class AsyncUIAvatar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error) {
    this.setState({
      hasError: true
    });
    setTimeout(() => {
      throw error;
    }, 0);
  }
  render() {
    return this.state.hasError ? /*#__PURE__*/_jsx(ErrorComponent, {}) : /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(LoadingComponent, {}),
      children: /*#__PURE__*/_jsx(UIAvatar, Object.assign({}, this.props))
    });
  }
}
AsyncUIAvatar.displayName = 'AsyncUIAvatar';
/**
 * This `AsyncUIAvatar` has a smaller loading component - this is used for the
 * ThreadListMember rows since the rendered avatar is smaller than default
 */
export class SmallerAsyncUIAvatar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error) {
    this.setState({
      hasError: true
    });
    setTimeout(() => {
      throw error;
    }, 0);
  }
  render() {
    return this.state.hasError ? /*#__PURE__*/_jsx(ErrorComponent, {}) : /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(SmallerLoadingComponent, {}),
      children: /*#__PURE__*/_jsx(UIAvatar, Object.assign({}, this.props))
    });
  }
}
SmallerAsyncUIAvatar.displayName = 'SmallerAsyncUIAvatar';
export default AsyncUIAvatar;